commusoftCommon.filter('normalDateFormat', function (CS_LANGUAGE) {
    return function (dateString) {
        if (dateString == '') {
            return '';
        }
        let language = CS_LANGUAGE;
        if(language == 'en'){
            language = 'en-GB';
        }
        moment.locale(language);
        if(language === 'en-GB') {
            return moment(dateString).format('DD/MM/YY');
        }else if(language === 'en-US'){
            return moment(dateString).format('MM/DD/YY');
        }else{
            return moment(dateString).format('DD/MM/YY');
        }

    };
});